var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Typography } from '@mui/material';
import { MuiStack } from '../../atoms/stackComponent';
import { t } from 'i18next';
// Job done accordian in Service detail modal in service history
export default function ServiceDetailsJobDone(props) {
    var filteredPartData = props.filteredPartData, filteredLabourData = props.filteredLabourData, selectedOption = props.selectedOption;
    var PartAndLabourData = __spreadArray(__spreadArray([], filteredPartData, true), filteredLabourData, true);
    return /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column'
    }, selectedOption === 'All' && (PartAndLabourData === null || PartAndLabourData === void 0 ? void 0 : PartAndLabourData.map(function (item, index) { /*#__PURE__*/ return React.createElement(MuiStack, {
        id: "jobs-done-card",
        paddingX: 2,
        paddingY: 1.5,
        spacing: 1.5,
        direction: "column",
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: '8px',
            marginTop: 2,
            backgroundColor: '#F4F7FA'
        },
        key: index
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "row",
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "ItemCode",
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, '#' + (item === null || item === void 0 ? void 0 : item.ItemCode)), /*#__PURE__*/ React.createElement(Typography, {
        id: "itemType",
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, item.jobType)), /*#__PURE__*/ React.createElement(Typography, {
        id: "itemName",
        variant: "h4"
    }, item === null || item === void 0 ? void 0 : item.ItemName), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "itemServiceType",
        variant: "h4",
        sx: {
            color: '#8593A3'
        }
    }, item.ContractTypeName), /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            marginTop: '10px',
            justifyContent: 'space-between'
        }
    }, item.Qty && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, t("Qty :")), /*#__PURE__*/ React.createElement(Typography, {
        id: "itemQty",
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            marginLeft: 0.5
        }
    }, item.Qty)), item.Amount && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, t("AMOUNT")), /*#__PURE__*/ React.createElement(Typography, {
        id: "itemAmt",
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            marginLeft: 0.5
        }
    }, (item === null || item === void 0 ? void 0 : item.Amount).toFixed(2)))))); })), selectedOption === 'Part' && (filteredPartData === null || filteredPartData === void 0 ? void 0 : filteredPartData.map(function (item, index) { /*#__PURE__*/ return React.createElement(MuiStack, {
        paddingX: 2,
        paddingY: 1.5,
        spacing: 1.5,
        direction: "column",
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: '8px',
            marginTop: 2,
            backgroundColor: '#F4F7FA'
        },
        key: index
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "row",
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, '#' + (item === null || item === void 0 ? void 0 : item.ItemCode)), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, t('Part'))), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4"
    }, item === null || item === void 0 ? void 0 : item.ItemName), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: '#8593A3'
        }
    }, item.ContractTypeName), /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            marginTop: '10px',
            justifyContent: 'space-between'
        }
    }, item.Qty && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, t("Qty :")), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            marginLeft: 0.5
        }
    }, item.Qty)), item.Amount && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, t("AMOUNT")), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            marginLeft: 0.5
        }
    }, (item === null || item === void 0 ? void 0 : item.Amount).toFixed(2)))))); })), selectedOption === 'Labour' && (filteredLabourData === null || filteredLabourData === void 0 ? void 0 : filteredLabourData.map(function (item, index) { /*#__PURE__*/ return React.createElement(MuiStack, {
        paddingX: 2,
        paddingY: 1.5,
        spacing: 1.5,
        direction: "column",
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: '8px',
            marginTop: 2,
            backgroundColor: '#F4F7FA'
        },
        key: index
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "row",
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, '#' + (item === null || item === void 0 ? void 0 : item.ItemCode)), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, t('Labour'))), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4"
    }, item === null || item === void 0 ? void 0 : item.ItemName), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: '#8593A3'
        }
    }, item.ContractTypeName), /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            marginTop: '10px',
            justifyContent: 'space-between'
        }
    }, item.Qty && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, t("Qty :")), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            marginLeft: 0.5
        }
    }, item.Qty)), item.Amount && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        }
    }, t("AMOUNT")), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: '12px',
            fontWeight: '500',
            marginLeft: 0.5
        }
    }, (item === null || item === void 0 ? void 0 : item.Amount).toFixed(2)))))); })));
}
